import React, { useState } from 'react';
import { X } from 'lucide-react';

interface TagsInputProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
}

/** Chips de tag livre: Enter ou vírgula confirma, backspace no campo vazio apaga a última. */
const TagsInput: React.FC<TagsInputProps> = ({ tags, onChange, disabled }) => {
  const [rascunho, setRascunho] = useState('');

  const adicionar = (bruta: string) => {
    const tag = bruta.trim().replace(/,$/, '');
    // Duplicata é comparada sem caixa pra não criar "Estratégico" e "estratégico" separados.
    if (!tag || tags.some(t => t.toLowerCase() === tag.toLowerCase())) { setRascunho(''); return; }
    onChange([...tags, tag]);
    setRascunho('');
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5 px-2 py-1.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg">
      {tags.map(tag => (
        <span key={tag} className="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-primary/10 text-primary">
          {tag}
          {!disabled && (
            <button type="button" onClick={() => onChange(tags.filter(t => t !== tag))} aria-label={`Remover ${tag}`}>
              <X size={12} />
            </button>
          )}
        </span>
      ))}
      {!disabled && (
        <input
          value={rascunho}
          onChange={e => setRascunho(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); adicionar(rascunho); }
            if (e.key === 'Backspace' && !rascunho && tags.length > 0) onChange(tags.slice(0, -1));
          }}
          onBlur={() => adicionar(rascunho)}
          placeholder={tags.length ? '' : 'Adicionar tag...'}
          className="flex-1 min-w-[110px] bg-transparent text-sm outline-none dark:text-slate-200"
        />
      )}
    </div>
  );
};

export default TagsInput;
